/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Meta_TitleInputs */

const en_svc_integration_meta_title = /** @type {(inputs: Svc_Integration_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Integration Services — LLM & AI API Integration | Lindevo`)
};

const lv_svc_integration_meta_title = /** @type {(inputs: Svc_Integration_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI integrācija — LLM un AI API integrācija uzņēmumiem | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Integration Services — LLM & AI API Integration \| Lindevo" |
*
* @param {Svc_Integration_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_meta_title = /** @type {((inputs?: Svc_Integration_Meta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Meta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_meta_title(inputs)
	return en_svc_integration_meta_title(inputs)
});